<script setup>
import {
	Chart as ChartJS,
	Filler,
	LineElement,
	PointElement,
	RadialLinearScale,
	Tooltip
} from 'chart.js';
import { Radar } from 'vue-chartjs';

ChartJS.register(
	RadialLinearScale,
	PointElement,
	LineElement,
	Filler,
	Tooltip
	// Legend
);

const props = defineProps({
	data: {
		type: Object,
		required: true
	}
});

/* This is where we store the common options for the chart */
const chartData = generateData(props.data);
function generateData (data) {
	const labels = [];
	const datasets = [];
	const tooltips = [];

	for (const point in data.points) {
		const value = data.points[point].value;
		if (value) {
			labels.push(data.points[point].label);
			datasets.push(value);
			tooltips.push(data.points[point].description);
		}
	}
	return {
		labels,
		datasets: [{
			customTooltips: tooltips,
			// lineTension: 0.1,
			label: data.destination,
			data: datasets, // This will be replaced with points from js_params
			fill: true,
			backgroundColor: 'rgb(46, 91, 139, .21)',
			borderColor: 'rgba(49,82,122, 1)',
			pointBackgroundColor: 'rgba(49,82,122, 1)',
			radius: 6,
			hoverBackgroundColor: '#f00',
			pointHoverBorderWidth: 2,
			pointHoverRadius: 8,
			pointHoverBackgroundColor: 'rgba(49,82,122, 1)',
			pointHoverBorderColor: 'rgba(49,82,122, 1)'
		}]
	};
}

const options = {
	responsive: true,
	borderJoinStyle: 'round',
	maintainAspectRatio: true,
	aspectRatio: 9 / 6,
	plugins: {
		legend: {
			labels: {
				font: {
					size: 14
				}
			}
		},
		tooltip: {
			boxPadding: 12,
			padding: 12,
			footerMarginTop: 24,
			borderWidth: 2,
			callbacks: {
				footer: generateTooltip
			}
		}
	},
	layout: {
		padding: 20,
		autoPadding: true
	},
	onResize: (chart, size) => {
		chart.options.scales.r.pointLabels.font.size = (size.width < 420) ? 10 : 12;
	},
	scales: {
		r: {
			min: 0,
			max: 100,
			beginAtZero: true,
			ticks: {
				display: false,
				stepSize: 50,
				callback: (value, tick, values) => {
					if (value === 100) {
						return '100';
					}
					return value;
				}
			},
			pointLabels: {
				color: '#31527A',
				font: {
					size: 14
				}
			},
			grid: {
				color: ['#D6E0F1']
			},
			angleLines: {
				display: true,
				drawTicks: false,
				color: ['#F1F4FA']
			}
		}
	},
	legend: {
		display: false
	},
	elements: {
		line: {
			borderWidth: 5
		}
	}
};

function generateTooltip (tooltipItems) {
	const selectedIndex = tooltipItems[0].dataIndex;
	const description = tooltipItems[0].dataset.customTooltips[selectedIndex];
	return description;
}


</script>


<template>
  <Radar
    :data="chartData"
    :options="options"
  />
</template>


<style>
article {
    padding: 0 24px 24px 24px;
}
@media (max-width: 768px) {
    article {
    padding: 0;
    }
    article canvas {
		padding: 0;
    }
}
</style>
